export const messages = {
  UPLOADED_SUCCESSFULLY: "Video or Photo uploaded successfully.",
  UPDATED_SUCCESSFULLY:  "Video or Photo updated successfully",
};